// TODO: Review is this being used
import {register} from '@shopify/theme-sections';
import cssClasses from '../helpers/cssClasses';

register('site-header-section', {
  onLoad() {
    this.init();
  },

  init() {
    this.setEventListeners();
  },

  setEventListeners() {
    const dropdown = document.querySelectorAll('[js-open="dropdown"]');

    dropdown.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const dropdown = item.dataset.open;
        const dropdownNode = document.querySelector(dropdown);
        dropdownNode.classList.toggle(cssClasses.active);
      });
    });
  },

  onBlockSelect: (blockId) => {
    document.querySelector(`#Meganav-${blockId}`).classList.remove(cssClasses.active);
  },

  onBlockDeselect: () => {
    const meganav = document.querySelectorAll('.meganav');

    meganav.forEach(item => {
      item.classList.remove(cssClasses.active);
    });
  },
});
